import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export const ViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 24px;
`;

export const HeaderGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(300px, 2.6fr) repeat(6, minmax(90px, 1fr)) 80px;
  column-gap: 12px;
  padding: 0 16px;
  min-width: 1040px;
`;

export const HeaderCell = styled.span`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
`;

export const RowList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 1040px;
`;

export const ListSelectAllRow = styled.div`
  display: flex;
  align-items: center;
  padding: 18px 12px 12px;
`;

export const ContentWrap = styled.div`
  position: relative;
`;

export const DimmedContent = styled.div<{ $dimmed: boolean }>`
  opacity: ${(props) => (props.$dimmed ? 0.6 : 1)};
  transition: opacity 120ms ease;
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;

export const Message = styled.div`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue4};
  padding: 24px 16px;
  border-radius: 16px;
  background: transparent;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: normal;
`;

export const LoadMoreSentinel = styled.div`
  width: 100%;
  height: 1px;
`;

export const LoadMoreWrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
`;

export const LoaderWrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
`;

export const Spinner = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 3px solid ${ColorV2.Blue6};
  border-top-color: ${ColorV2.Blue1};
  animation: timeReportsSpin 0.8s linear infinite;

  @keyframes timeReportsSpin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const SelectionBanner = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 24px;
  z-index: 40;
  display: flex;
  justify-content: center;
  padding: 0 24px;
  pointer-events: none;
`;

export const SelectionBannerCard = styled.div`
  width: 100%;
  max-width: 1020px;
  min-width: 920px;
  border: 1px solid ${ColorV2.Blue6};
  border-radius: 44px;
  background: ${ColorV2.White};
  box-shadow: 0 18px 40px rgba(12, 45, 72, 0.16);
  padding: 28px 46px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
  pointer-events: auto;
`;

export const SelectionInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SelectionCount = styled.span`
  ${TypographyV2.b1};
  color: ${ColorV2.Blue1};
`;

export const SelectionTotal = styled.span`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
`;

export const SelectionActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
`;

export const SelectionHint = styled.span`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
`;
